// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;Lead me, Lord, in your righteousness,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;because of my enemies;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;make your way straight before my face.<br> </p> </div></div>";
// Exports
module.exports = code;